export default "__VITE_ASSET__63858ccc__"